<template>
  <v-container>
    <v-card flat>
      <v-card-title class="error white--text">
        Debtors List upto {{ toDate }}
        <v-spacer></v-spacer>
        <v-btn
          v-if="sales.length"
          icon
          class="d-print-none"
          @click="PrintPage"
          small
          color="white"
        >
          <v-icon>fas fa-print</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card flat>
          <v-card-title>
            <!-- {{ TranInfo.FullName }} -->

            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="fas fa-search"
              label="Search"
              outlined
              dense
              single-line
              hide-details
              class="d-print-none"
            ></v-text-field>
          </v-card-title>

          <v-data-table
            flat
            :headers="headers"
            :items="DeptList"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="grey lighten-4">
                <v-toolbar-items class="mt-7">
                  <base-date
                    :disabled="isloading"
                    :loading="isloading"
                    dense
                    v-model="toDate"
                  />
                </v-toolbar-items>
                <v-spacer></v-spacer>
                <div>
                  <cashDisplay
                    :isloading="isloading"
                    :Balance="TotalSale"
                  ></cashDisplay>
                </div>
              </v-toolbar>
            </template>
            <template v-slot:[`item.Amount`]="{ item }">
              {{ item.Amount && Math.abs(item.Amount).toLocaleString() }}
              {{ item.AmountType | MoneySigns }}
            </template>
            <template v-slot:[`item.print`]="{ item }">
              <span class="d-print-none">
                <DeptView :key="item.Description" :Deptor="item"></DeptView>
              </span>
            </template>
            <template v-slot:[`item.pay`]="{ item }">
              <span class="d-print-none">
                <paymentForm
                  :key="item.Description + 'payment'"
                  :Debtor="item"
                ></paymentForm>
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { EventBus } from "@/main";
import { mapGetters } from "vuex";
import { printTable } from "@/Mixins/printTable";
import printJS from "print-js";
export default {
  mixins: [printTable],
  components: {
    cashDisplay: () => import("@/components/util/displayCash"),
    DeptView: () => import("@/components/Branches/Deptors/DeptorList.vue"),
    paymentForm: () => import("@/components/Branches/Deptors/Payment.vue"),
  },
  data() {
    return {
      SalesRepo: "/Reports/debtors",
      searching: false,
      isloading: false,

      search: "",
      fromDate: "",
      toDate: "",
      sales: [],
      headers: [
        {
          text: "Client",
          align: "left",
          value: "Name",
        },
        { text: "Phone", value: "phone" },
        { text: "Balance", value: "Amount" },
        { text: "View", class: "d-print-none", value: "print" },
        { text: "Pay", class: "d-print-none", value: "pay" },
      ],
    };
  },
  computed: {
    ...mapGetters(["UsersToken"]),
    DeptList() {
      return this.sales.filter(debt => debt.Amount > 0);
    },
    TotalSale() {
      if (!this.DeptList.length) return [];
      return [
        {
          Amount: this.DeptList.reduce((t, s) => (t += s.Amount), 0),
          AmountType: this.UsersToken.CashBase,
        },
      ];
    },
    AvailibleBalanceArray() {
      return this.TotalSale;
    },
  },
  watch: {
    toDate(v) {
      // console.log(v);
      this.OnSearch(null, v);
    },
  },
  methods: {
    PrintPage() {
      // console.log(this.UsersToken.UserBranch);
      // console.log("printing");
      let prHeader = [
        { value: "index", text: "#" },
        // ...this.headers.filter(
        //   head =>
        //     head.text !== "View" && head.text !== "Pay" && head.text !== "Phone"
        // ),
        { value: "Name", text: "Client", width: "250px" },
        // { text: "Phone", value: "phone" },
        { value: "Amount", text: "Balance" },
        { value: "note", text: "Note", width: "150px" },
      ];
      let myTitle = `DEEMAHA ( ${this.UsersToken.UserBranch} ) ${this.toDate}`;
      const myPrintTable = this.PrintReport(
        this.DeptList.reverse(),
        prHeader,
        myTitle.toUpperCase()
      );

      printJS({
        printable: myPrintTable,
        type: "html",
        style: this.CustomStyle("#ff5252", "#ffffff"),
        repeatTableHeader: false,
      });
    },
    async PrintPage2() {
      //   this.itemPerPage = this.Transactions.length;
      this.headers.pop();
      this.headers.pop();
      await EventBus.Printing(false);
      window.print();
      EventBus.Printing(true);
      this.headers = [
        ...this.headers,
        { text: "View", class: "d-print-none", value: "print" },
        { text: "Pay", class: "d-print-none", value: "pay" },
      ];

      //   this.itemPerPage = 10;
    },
    OnSearch(from, to) {
      this.fromDate = from;
      this.toDate = to;

      this.sales = [];

      this.searching = true;
      this.isloading = true;

      this.GetReq()
        .then(result => {
          // console.log(result[0]);
          this.isloading = false;
          this.searching = false;
          this.sales = result.data;
        })
        .catch(() => {
          this.isloading = false;
          this.searching = false;
          // console.log(error);
        });
    },
    GetReq() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: this.SalesRepo,
        query: { from: this.fromDate, to: this.toDate },
      });
    },
    loadSales() {
      try {
        // this.$store
        //   .dispatch("GET_ONLY", this.SalesRepo)
        this.searching = true;
        this.isloading = true;
        this.GetReq()
          .then(value => {
            this.searching = false;
            this.isloading = false;
            this.sales = value.data;
          })
          .catch(err => {
            this.searching = false;
            this.isloading = false;
            console.log(err);
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    const { date } = this.Current();
    this.fromDate = date;
    this.toDate = date;
    // this.loadSales();
  },
};
</script>
